<template>
	<div>
		<notifications position="top center" group="info" />

		<h1>Groupe</h1>
		<p>Nom :</p>
		<b-input v-model="group.name"></b-input>
		<br />
		<div id="jsoneditor"></div>
		<b-button @click="update">Mettre à jour</b-button>
	</div>
</template>

<script>
	var clone = require("clone");

	import projects from "../services/projects.js";
	import client_service from "../services/client.js";
	import groups from "../services/groups.js";
	import users from "../services/users.js";
	import store from "../store";

	import { JSONEditor } from "@json-editor/json-editor";

	export default {
		name: "group",
		data() {
			return {
				group: { rules: {} },
				project: [],
				projects_libelle: {},
				projects_uid: {},
				list_groups: [],
				list_groups_libelle: {},
				list_groups_uid: {},
			};
		},
		methods: {
			update: async function () {
				var group = clone(this.group);

				console.log(group)

				if (Array.isArray(group.rules.projects))
					for (var i = 0; i < group.rules.projects.length; i++) {
						group.rules.projects[i] =
							this.projects_libelle[group.rules.projects[i]];
					}

				if (Array.isArray(group.rules.projects_hide))
					for (var i = 0; i < group.rules.projects_hide.length; i++) {
						group.rules.projects_hide[i] =
							this.projects_libelle[group.rules.projects_hide[i]];
					}
					
				var utilisateurs_filters = "";
				if (Array.isArray(group.rules.utilisateurs_filters_groupes) && group.rules.utilisateurs_filters_groupes.length > 0)
				{
					utilisateurs_filters += '('
					for (var i = 0; i < group.rules.utilisateurs_filters_groupes.length; i++) {
						if (i > 0)
							utilisateurs_filters += " OR "
						group.rules.utilisateurs_filters_groupes[i] = this.list_groups_libelle[group.rules.utilisateurs_filters_groupes[i]];
						utilisateurs_filters += "groups = '" + group.rules.utilisateurs_filters_groupes[i] + "'";
					}
					utilisateurs_filters += ")"
				}

				if (group.rules.utilisateurs_filters_end)
				{
					if (utilisateurs_filters)
						utilisateurs_filters += " AND ";
					utilisateurs_filters += group.rules.utilisateurs_filters_end;
				}

				group.rules.utilisateurs_filters = utilisateurs_filters;
				
				var messages_filters = "";
				if (Array.isArray(group.rules.messages_filters_groupes))
				{
					messages_filters += '('
					for (var i = 0; i < group.rules.messages_filters_groupes.length; i++) {
						if (i > 0)
							messages_filters += " OR "
						group.rules.messages_filters_groupes[i] = this.list_groups_libelle[group.rules.messages_filters_groupes[i]];
						messages_filters += "groups like '%" + group.rules.messages_filters_groupes[i] + "%'";
					}
					messages_filters += ")"
				}

				if (group.rules.messages_filters_end)
				{
					if (messages_filters)
						messages_filters += " AND ";
					messages_filters += group.rules.messages_filters_end;
				}

				group.rules.messages_filters = messages_filters;

				if (group.rules.project_new_user)
					group.rules.project_new_user = this.projects_libelle[group.rules.project_new_user];

				if (group.rules.project_update_user)
					group.rules.project_update_user = this.projects_libelle[group.rules.project_update_user];

				// config_type : tableau [{ type, personal, shared, client }] → objet { type: {personal, shared, client} } pour la sauvegarde
				if (Array.isArray(group.rules.config_type)) {
					const obj = {};
					for (const row of group.rules.config_type) {
						if (row.type) obj[row.type] = { personal: !!row.personal, shared: !!row.shared, client: row.client || 'false' };
					}
					group.rules.config_type = obj;
				}

				group = await groups.update(group);

				if (group) {
					this.$notify({
						group: "info",
						title: "Modification sur le groupe enregistré",
						type: "success",
					});
				} else {
					this.$notify({
						group: "info",
						title: "Un erreur c'est produite durant l'enregistrement",
						type: "error",
					});
				}
			},
		},
		created: async function () {
			if (store.state.user.rules && !store.state.user.rules.groupes) {
				this.$router.push({ name: "profile" });
			}

			var self = this;

			this.projects = await projects.getAll();
			var enum_projects = [""];
			for (var i = 0; i < this.projects.length; i++) {
				enum_projects.push(this.projects[i].libelle);
				this.projects_libelle[this.projects[i].libelle] =
					this.projects[i].uid;
				this.projects_uid[this.projects[i].uid] =
					this.projects[i].libelle;
			}


			this.list_groups = await client_service.getClientGroups();
			var enum_groups = [];
			for (var i = 0; i < this.list_groups.length; i++) {
				enum_groups.push(this.list_groups[i].name);
				this.list_groups_libelle[this.list_groups[i].name] = this.list_groups[i].uid;
				this.list_groups_uid[this.list_groups[i].uid] = this.list_groups[i].name;
			}

			this.group = await groups.get(this.$route.params.id);

			if (!this.group) {
				this.group = {
					name: "",
					uid: this.$route.params.id,
					client_uid: store.state.user.client_uid,
					rules: {},
				};
			}

			let response = await users.getSelf(true);
			let client = response.client;

			if (client.details && client.details.tables) {
				if (!this.group.rules.database_tables)
					this.group.rules.database_tables = [];
				var tables_rules = [];
				
				var tables_rules_names = [];
				if (Array.isArray(this.group.rules.database_tables)) {
					for (var i = 0; i < this.group.rules.database_tables.length;i++) 
					{
						tables_rules_names.push(this.group.rules.database_tables[i].name);
						tables_rules.push(this.group.rules.database_tables[i]);
					}
				}
				for (var i = 0; i < client.details.tables.length; i++) 
				{
					if (!tables_rules_names.includes(client.details.tables[i].name)) 
					{
						tables_rules.push({
							name: client.details.tables[i].name,
						});
					}
				}
				if (Array.isArray(this.group.rules.database_tables))
					this.group.rules.database_tables = tables_rules;
				console.log(this.group.rules.database_tables)
			}

			var enum_profile = ["tout", "soi-même"];
			if (client.details && client.details.profile) {
				for (var i = 0; i < client.details.profile.length; i++) {
					enum_profile.push(client.details.profile[i].name);
				}
			}

			const element = document.getElementById("jsoneditor");

			var schema = {
				title: "Rôles",
				type: "object",
				format: "table",
				properties: {
					projects: {
						title: "Projets accessibles",
						anyOf: [
							{
								type: "boolean",
								title: "Tout les projets",
							},
							{
								title: "Certains projets",
								type: "array",
								format: "select",
								uniqueItems: true,
								items: {
									type: "string",
									enum: enum_projects,
								},
							},
						],
					},
					projects_hide: {
						title: "Projets cachés dans la création des projets",
						type: "array",
						format: "select",
						uniqueItems: true,
						items: {
							type: "string",
							enum: enum_projects,
						},
					},
					hide_create_projects: {
						title: "Cacher la création des traitements",
						type: "boolean",
						format: "checkbox",
					},
					treatment_view: {
						title: "Filtrer la visualisation des traitements",
						type: "string",
						enum: enum_profile,
					},
					projects_csv: {
						title: "Traitement csv",
						type: "boolean",
						format: "checkbox",
						default: true
					},
					workflow: {
						title: "Workflow",
						type: "boolean",
						format: "checkbox",
						default: true
					},
					projects_list: {
						title: "Liste des traitements",
						type: "boolean",
						format: "checkbox",
						default: true
					},
					treatment_details: {
						title: "Détails des traitements et fichiers",
						type: "boolean",
						format: "checkbox",
						default: false
					},
					dashboard: {
						title: "Tableau de bord - nom",
						type: "string",
					},
					validation: {
						title: "Validation",
						type: ["string", "boolean"],
						default: false,
					},
					actions: {
						type: "boolean",
						format: "checkbox",
						title: "Actions",
					},
					actions_sql: {
						title: "Actions - droits sql",
						type: "string",
					},
					actions_config: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des actions",
					},
					tickets: {
						type: "boolean",
						format: "checkbox",
						title: "Tickets",
					},
					document: {
						type: "boolean",
						format: "checkbox",
						title: "Documents",
					},
					document_tags: {
						type: "boolean",
						format: "checkbox",
						title: "Documents - fonctionnement par tags",
					},
					document_rules: {
						type: "object",
						format: "object",
						title: "Documents - règles",
						properties: {
							create: {
								type: "boolean",
								format: "checkbox",
								title: "Créer",
							},
							create_folder: {
								type: "boolean",
								format: "checkbox",
								title: "Créer des dossiers",
							},
							update: {
								type: "boolean",
								format: "checkbox",
								title: "Update",
							},
							delete: {
								type: "boolean",
								format: "checkbox",
								title: "Supprimer",
							},
							root_folder: {
								type: "string",
								title: "Dossier racine",
							},
						},
					},
					document_rules_tags: {
						type: "array",
						title: "Documents - droits par tags",
						options: {
							disable_array_add: false,
							disable_array_delete: false
						},
						items: {
							format: "table",
							type: "array",
							title: "Règles",
							items: {
								type: "object",
								title: "Règle",
								properties: {
									type: {
										type: "string",
										enum: (client.details.tags ? Object.keys(client.details.tags) : []),
										title: "Type"
									},
									type_value: {
										type: "string",
										enum: ["valeur", "profil"],
										title: "Type de valeur"
									},
									value: {
										type: "string",
										title: "Valeur"
									},
									separator: {
										type: "string",
										title: "Séparateur"									
									},
									no: {
										type: "boolean",
										format: "checkbox",
										title: "Ne contient pas"									
									}
								}
							}
						},
					},
					document_tags_actions: {
						type: "boolean",
						format: "checkbox",
						title: "Documents - Manipulation des tags sur le documents",
					},
					document_rules_sql: {
						title: "Documents - droits sql",
						type: "string"
					},
					document_share_rules_sql: {
						title: "Documents - documents partagés",
						type: "string"
					},
					messages: {
						type: "boolean",
						format: "checkbox",
						title: "Messages",
					},
					messages_filters_groupes: {
						title: "Filtres des groupes sur les destinataires des messages",
						type: "array",
						format: "select",
						uniqueItems: true,
						items: {
							type: "string",
							enum: enum_groups,
						}
					},
					messages_filters_end: {
						type: "string",
						title: "Filtres complémentaires sur les destinataires des messages"
					},
					messages_filters: {
						type: "string",
						title: "Filtres sur les messages",
						options: {
							hidden: true,
						}
					},
					formulaire: {
						type: "boolean",
						format: "checkbox",
						title: "Formulaires",
					},
					formulaire_where: {
						type: "string",
						title: "Filtres des formulaires",
					},
					formulaire_description: {
						type: "string",
						format: "textarea",
						title: "Formulaire - description",
					},
					ensemble: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des ensembles",
					},
					variants: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des variantes",
					},
					compare: {
						type: "boolean",
						format: "checkbox",
						title: "Comparaisons de fichiers",
					},
					scenarios: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des scénarios",
					},
					scraping: {
						type: "boolean",
						format: "checkbox",
						title: "Aide à la configuration du scraping",
					},
					form: {
						type: "boolean",
						format: "checkbox",
						title: "Aide à la configuration de formulaire",
					},
					decument_extraction: {
						type: "boolean",
						format: "checkbox",
						title: "Aide à l'extraction de document",
					},
					decument_extraction_configuration: {
						type: "boolean",
						format: "checkbox",
						title: "Aide à l'extraction de document - configuration",
					},
					elements: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des éléments",
					},
					code_execution: {
						type: "boolean",
						format: "checkbox",
						title: "Exécution de code personnalisé (fonction / script)",
					},
					code_execution_name: {
						type: "boolean",
						format: "checkbox",
						title: "Exécution de code sauvegardé par nom (bibliothèque)",
					},
					library: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion de la bibliothèque",
					},
					generate_ia: {
						type: "boolean",
						format: "checkbox",
						title: "Générer avec l'IA",
						default: false
					},
					library_hide_menu: {
						type: "boolean",
						format: "checkbox",
						title: "Cacher la gestion de la bibliothèque dans le menu",
					},
					library_type: {
						type: "object",
						title: "Filtres pour la bibliothèque",
						additionalProperties: {
							type: "string"
						}
					},
					config_client: {
						type: "string",
						title: "Configurations client (configs partagées avec tout le client)",
						enum: ["edit", "view", "false"],
						default: "false"
					},
					config_personal: {
						type: "boolean",
						format: "checkbox",
						title: "Configurations - gérer ses propres configs personnelles",
						default: false
					},
					config_shared: {
						type: "boolean",
						format: "checkbox",
						title: "Configurations - partager ses configs personnelles (lecture seule)",
						default: false
					},
					config_set_default: {
						type: "boolean",
						format: "checkbox",
						title: "Configurations - définir une configuration publique comme défaut",
						default: false
					},
					config_type: {
						type: "array",
						title: "Configurations - droits par type (chart, table...) — surcharge les 3 droits globaux",
						format: "table",
						items: {
							type: "object",
							properties: {
								type: {
									type: "string",
									title: "Type"
								},
								personal: {
									type: "boolean",
									format: "checkbox",
									title: "Personnelle",
									default: false
								},
								shared: {
									type: "boolean",
									format: "checkbox",
									title: "Partagée",
									default: false
								},
								client: {
									type: "string",
									title: "Publique",
									enum: ["edit", "view", "false"],
									default: "false"
								}
							}
						}
					},
					planification: {
						type: "boolean",
						format: "checkbox",
					},
					documentation: {
						type: "boolean",
						format: "checkbox",
						title: "Documentation",
					},
					share: {
						type: "boolean",
						format: "checkbox",
						title: "Partage d'élément",
					},
					share_get: {
						type: "boolean",
						format: "checkbox",
						title: "Partage d'élément - récupération",
					},
					database: {
						type: "string",
						title: "Base de données",
						enum: ["activé", "certaines tables", "désactivé"],
					},
					database_tables: {
						title: "Tables",
						format: "table",
						type: "array",
						options: {
							disable_collapse: false,
							disable_array_add: true,
							disable_array_delete: true,
							disable_array_reorder: true,
						},
						default: tables_rules,
						items: {
							type: "object",
							properties: {
								name: {
									title: "Nom",
									readOnly: true,
									type: "string",
								},
								create: {
									title: "Créer",
									type: "boolean",
									default: false,
									format: "checkbox",
								},
								read: {
									title: "Lire",
									type: "boolean",
									default: false,
									format: "checkbox",
								},
								update: {
									title: "Modifier",
									type: "boolean",
									default: false,
									format: "checkbox",
								},
								delete: {
									title: "Supprimer",
									type: "boolean",
									default: false,
									format: "checkbox",
								},
								actions: {
									title: "Actions",
									type: "boolean",
									default: "true",
									format: "checkbox",
								},
								hide: {
									title: "Cacher",
									type: "boolean",
									default: false,
									format: "checkbox",
								},
								filters: {
									title: "Filtrer",
									type: "string",
								},
							},
						},
					},
					db_requests: {
						type: "boolean",
						format: "checkbox",
						title: "Base de données - requêtes"
					},
					db_requests_view: {
						type: "boolean",
						format: "checkbox",
						title: "Base de données - vues multitables"
					},
					database_buttons: {
						title: "Boutons dans la base de données",
						type: "object",
						format: "table",
						properties: {
							search_bar: {
								type: "boolean",
								format: "checkbox",
								title: "Barre de recherche",
								default: true
							},
							sql: {
								type: "boolean",
								format: "checkbox",
								title: "Voir le sql",
								default: true
							},
							id_columns: {
								type: "boolean",
								format: "checkbox",
								title: "Colonnes id",
								default: false
							},
							structure: {
								type: "boolean",
								format: "checkbox",
								title: "Structure",
								default: true
							},
							new_line: {
								type: "boolean",
								format: "checkbox",
								title: "Nouvelle ligne",
								default: false
							},
							update: {
								type: "boolean",
								format: "checkbox",
								title: "Mise à jour",
								default: true
							},
							delete_from_csv: {
								type: "boolean",
								format: "checkbox",
								title: "Supprimer à partir d'un csv",
								default: false
							},
							upddate_from_csv: {
								type: "boolean",
								format: "checkbox",
								title: "Mise à jour à partir d'un csv",
								default: false
							},
							fusion: {
								type: "boolean",
								format: "checkbox",
								title: "Fusion",
								default: false
							},
							select: {
								type: "boolean",
								format: "checkbox",
								title: "Select",
								default: false
							}
						}
					},
					tabulator_button: {
						title: "Boutons dans les tableaux",
						type: "object",
						format: "table",
						properties: {
							filters: {
								type: "boolean",
								format: "checkbox",
								title: "Filtres",
								default: true
							},
							add_line: {
								type: "boolean",
								format: "checkbox",
								title: "Ajouter une ligne",
								default: true
							},
							add_column: {
								type: "boolean",
								format: "checkbox",
								title: "Ajouter un colonne",
								default: true
							},
							download: {
								type: "boolean",
								format: "checkbox",
								title: "Télécharger",
								default: true
							}
						}
					},
					credentials: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des clés de sécurité",
					},
					notifications: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des notifications",
					},
					client_var: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des variables client",
					},
					fields_profile: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des champs utilisateur",
					},
					utilisateurs: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des utilisateurs",
					},
					tags: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des tags",
					},
					utilisateurs_filters_groupes: {
						title: "Filtres des groupes sur les utilisateurs",
						type: "array",
						format: "select",
						uniqueItems: true,
						items: {
							type: "string",
							enum: enum_groups,
						}
					},
					utilisateurs_filters_end: {
						type: "string",
						title: "Filtres complémentaires sur les utilisateurs"
					},
					utilisateurs_filters: {
						type: "string",
						title: "Filtres sur les utilisateurs",
						options: {
							hidden: true,
						}
					},
					groupes: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des groupes",
					},
					style: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion du style",
					},
					env: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des environnements",
					},
					admin: {
						type: "boolean",
						format: "checkbox",
						title: "Admin",
					},
					viewver_params: {
						type: "boolean",
						format: "checkbox",
						title: "Gestion des paramètres des visualisations",
					},
					change_env: {
						type: "boolean",
						format: "checkbox",
						title: "Sur le profil, pouvoir changer d'environnement",
					},
					jwt: {
						type: "boolean",
						format: "checkbox",
						title: "Sur le profil, pouvoir voir le token d'authentification",
					},
					jwt_generate: {
						type: "boolean",
						format: "checkbox",
						title: "Sur le profil, pouvoir générer le token d'authentification",
					},
					password: {
						type: "boolean",
						format: "checkbox",
						title: "Sur le profil, pouvoir changer de mot de passe",
						default: true
					},
					project_new_user: {
						title: "Projet nouvel utilisateur",
						type: "string",
						enum: enum_projects
					},
					project_update_user: {
						title: "Projet utilisateur modifié",
						type: "string",
						enum: enum_projects
					},
					treatments_stats: {
						title: "Stats client (utilisateurs, traitements, dashboards admin...)",
						type: "boolean",
						format: "checkbox"
					},
					doc: {
						title: "Documentation client (base de données, projets...)",
						type: "boolean",
						format: "checkbox"
					},
					login: {
						type: "string",
						title: "Page d'accueil lors de la connexion",
					},
					logout: {
						type: "string",
						title: "Url de redirection lors de la déconnexion",
					}
				},
			};

			this.editor = new JSONEditor(element, {
				schema: schema,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				object_background: "",
				required_by_default: true,
				disable_collapse: true,
				disable_edit_json: false,
				disable_properties: true,
			});

			await new Promise((resolve, reject) => {
				self.editor.on("ready", function () {
					if (resolve) resolve();
				});
			});

			this.editor.on("change", function () {
				self.group.rules = self.editor.getValue();
			});

			if (this.group) {
				if (Array.isArray(this.group.rules.projects)) {
					for (var i = 0; i < this.group.rules.projects.length; i++) {
						this.group.rules.projects[i] =
							this.projects_uid[this.group.rules.projects[i]];
					}
				}


				if (Array.isArray(this.group.rules.projects_hide)) {
					for (var i = 0; i < this.group.rules.projects_hide.length; i++) {
						this.group.rules.projects_hide[i] =
							this.projects_uid[this.group.rules.projects_hide[i]];
					}
				}

				if (Array.isArray(this.group.rules.utilisateurs_filters_groupes)) {
					for (var i = 0; i < this.group.rules.utilisateurs_filters_groupes.length; i++) {
						this.group.rules.utilisateurs_filters_groupes[i] =
							this.list_groups_uid[this.group.rules.utilisateurs_filters_groupes[i]];
					}
				}

				if (Array.isArray(this.group.rules.messages_filters_groupes)) {
					for (var i = 0; i < this.group.rules.messages_filters_groupes.length; i++) {
						this.group.rules.messages_filters_groupes[i] =
							this.list_groups_uid[this.group.rules.messages_filters_groupes[i]];
					}
				}

				if (this.group.rules.project_new_user)
					this.group.rules.project_new_user = this.projects_uid[this.group.rules.project_new_user];

				if (this.group.rules.project_update_user)
					this.group.rules.project_update_user = this.projects_uid[this.group.rules.project_update_user];

				// config_type : objet { type: {personal,shared,client} } → tableau pour l'affichage
				if (this.group.rules.config_type && typeof this.group.rules.config_type === 'object' && !Array.isArray(this.group.rules.config_type)) {
					this.group.rules.config_type = Object.entries(this.group.rules.config_type)
						.map(([type, val]) => {
							if (val && typeof val === 'object')
								return { type, personal: !!val.personal, shared: !!val.shared, client: val.client || 'false' };
							// Ancien format (string)
							return { type, personal: val !== false && val !== 'false', shared: false, client: typeof val === 'string' ? val : 'false' };
						});
				}

				this.editor.setValue(this.group.rules);
			}
		},
	};
</script>

<style></style>
